const videoStyles = {
    video:{
      width: "100vw",
      height: 65,
      backgroundColor: "#F7F7F7",
      display: "block",
      borderTop: "2px solid #e2e2e2",
      borderBottom: "2px solid #e2e2e2",
      top:"55px",
      position:"relative"
    },
    pauseButton:{
      height: "32px",
      zIndex: "1000",
      width: "48px",
      borderRadius: "11px",
      backgroundColor: "rgba(0,0,0,0.39)",
      position:"absolute",
      top:"5%",
      left:"2%",
      color:"#fff",
      fontSize:"20px",
  },
}

export default videoStyles;
